module.exports = __webpack_public_path__ + "static/media/i_featured_client.39f55870.svg";